module.exports = __webpack_public_path__ + "d994e0a2c5b0723d8e17e089979e02f8.svg";